import { Publisher } from '@/module/Journal';

import { Author, AuthorRequest, IdentityRequest } from '@feature/utils';

export const dictionaryTypeList = ['DICTIONARY', 'ENCYCLOPEDIA', 'ATLAS'] as const;
export type DictionaryType = (typeof dictionaryTypeList)[number];

export const printTypeList = ['PRINT', 'ONLINE'] as const;
export type PrintType = (typeof printTypeList)[number];

export interface Dictionary {
  id: number;
  title: string;
  type: DictionaryType;
  printType: PrintType;
  isbnPrint: string;
  eisbn: string;
  link: string;
  publicationYear: number;

  noOfPages: number;

  publisher: Publisher;
  authors: Author[];
}

export interface DictionaryRequest {
  title: string;
  type: DictionaryType;
  printType: PrintType;
  isbnPrint: string;
  eisbn: string;
  link: string;
  publicationYear: number;

  noOfPages: number;

  publisher: IdentityRequest;
  authors: AuthorRequest[];
}
